import { css } from 'styled-components';
import colors from '../../style/colors';

const variants = {
  white: css`
    background: ${colors.white};
  `,
  pumpkin: css`
    background: ${colors.pumpkin};
  `,
  coral: css`
    background: ${colors.coral};
  `,
  bubbleGum: css`
    background: ${colors.bubbleGum};
  `,
  violet: css`
    background: ${colors.violet};
  `,
  ametystPurple: css`
    background: ${colors.ametystPurple};
  `,
  raspberryPink: css`
    background: ${colors.raspberryPink};
  `,
  amberGlow: css`
    background: ${colors.amberGlow};
  `,
};

export { variants };
